import React from "react";

const RemoveFromFolderIcon = ({ size = 14, fill = "black" }) => (
  <svg width={size} height={size} viewBox='0 0 37 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M32.7863 9.41283H18.3622L13.6493 4.9048C13.5893 4.84866 13.5104 4.81711 13.4283 4.81641H3.2149C2.50374 4.81641 1.92918 5.39096 1.92918 6.10212V29.8878C1.92918 30.599 2.50374 31.1735 3.2149 31.1735H32.7863C33.4975 31.1735 34.072 30.599 34.072 29.8878V10.6985C34.072 9.98739 33.4975 9.41283 32.7863 9.41283ZM31.1792 28.2807H4.82204V7.70926H12.3957L17.2011 12.3057H31.1792V28.2807Z'
      fill={fill}
    />
    <circle cx='30.5' cy='25.4702' r='5.5' fill='white' stroke={fill} strokeWidth='2' />
    <path d='M28.544 26.5302V24.8342H32.608V26.5302H28.544Z' fill={fill} />
  </svg>
);

export default RemoveFromFolderIcon;
